import { Input } from '@nextui-org/react'
import React from 'react'

export default function InputDefault(props) {
  const {
    name, type, label, placeholder,
    isRequired = false, formData, errors = {},
    onChange,
    className = "mb-4",
    size = "md",
    disabled = false,
    startContent = null, endContent = null,
    autoFocus = false
  } = props
  return (
    <>
      <Input
        name={name} type={type} label={label}
        isRequired={isRequired}
        placeholder={placeholder}
        value={formData[name] || ''}
        color={errors[name] ? 'danger' : 'default'}
        errorMessage={errors[name]}
        onChange={onChange}
        className={`${className}`}
        size={size}
        startContent={startContent}
        endContent={endContent}
        disabled={disabled}
        autoFocus={autoFocus}
      />
      {errors[name] && (
        <div className="pl-4 -mt-4 mb-2">
          {errors[name].map((error, index) => (
            <p key={index} className="text-xs text-danger">{error}</p>
          ))}
        </div>
      )}
    </>
  )
}
